<app-authentication-container *ngIf="merchantId">
  <app-merchant-user-registration-form
    [merchantId]="merchantId"
    [errorResponse]="errorResponse$ | async"
    [isLoading]="isLoading$ | async"
    (continue)="onContinue($event)"
  ></app-merchant-user-registration-form>
</app-authentication-container>
